"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addCategroy = addCategroy;
exports.articleInfoApi = articleInfoApi;
exports.categroyByIds = categroyByIds;
exports.categroyUpdateStatus = categroyUpdateStatus;
exports.deleteCategroy = deleteCategroy;
exports.infoCategroy = infoCategroy;
exports.listCategroy = listCategroy;
exports.treeCategroy = treeCategroy;
exports.updateCategroy = updateCategroy;

var _request = _interopRequireDefault(require("@/utils/request"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 新增分类
 * @param pram
 */
function addCategroy(pram) {
  var data = {
    extra: pram.extra,
    name: pram.name,
    pid: pram.pid,
    sort: pram.sort,
    status: pram.status,
    type: pram.type,
    url: pram.url
  };
  return (0, _request.default)({
    url: '/admin/category/save',
    method: 'POST',
    params: data
  });
}
/**
 * 分类详情
 * @param pram
 */


function infoCategroy(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/category/info',
    method: 'GET',
    params: data
  });
}
/**
 * 删除分类
 * @param pram
 */


function deleteCategroy(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/category/delete',
    method: 'GET',
    params: data
  });
}
/**
 * 分类列表
 * @param pram
 */


function listCategroy(pram) {
  var data = {
    limit: pram.limit,
    name: pram.name,
    page: pram.page,
    pid: pram.pid,
    status: pram.status,
    type: pram.type
  };
  return (0, _request.default)({
    url: '/admin/category/list',
    method: 'GET',
    params: data
  });
}
/**
 * 分类数据tree数据
 * @param pram
 */


function treeCategroy(pram) {
  var data = {
    type: pram.type,
    status: pram.status,
    name: pram.name
  };
  return (0, _request.default)({
    url: '/admin/category/list/tree',
    method: 'GET',
    params: data
  });
}
/**
 * 更新分类
 * @param pram
 */


function updateCategroy(pram) {
  var data = {
    extra: pram.extra,
    name: pram.name,
    pid: pram.pid,
    sort: pram.sort,
    status: pram.status,
    type: pram.type,
    url: pram.url,
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/category/update',
    method: 'POST',
    params: data
  });
}
/**
 * 根据id集合查询对应分类列表
 * @param pram
 */


function categroyByIds(pram) {
  var data = {
    ids: pram.ids
  };
  return (0, _request.default)({
    url: '/admin/category/list/ids',
    method: 'GET',
    params: data
  });
}
/**
 * 修改 显示关闭状态
 * @param pram
 */


function categroyUpdateStatus(id) {
  return (0, _request.default)({
    url: "/admin/category/updateStatus/".concat(id),
    method: 'GET'
  });
}
/**
 * 文章详情
 * @param pram
 */


function articleInfoApi(params) {
  return (0, _request.default)({
    url: "/admin/article/info",
    method: 'GET',
    params: params
  });
}